import { gql } from '@apollo/client'
import { CHATBOT_CONVERSATION_FIELDS } from './fragments/chatbot_conversation'

export const ALL_CHATBOT_CONVERSATIONS = gql`
  ${CHATBOT_CONVERSATION_FIELDS}
  query allChatbotConversations(
    $sorts: [ChatbotConversationSort!]
    $dynamicFilters: [ChatbotConversationDynamicFilterItem!]
    $page: Int
    $perPage: Int
    $query: String
  ) {
    allChatbotConversations(
      sorts: $sorts
      dynamicFilters: $dynamicFilters
      page: $page
      perPage: $perPage
      query: $query
    ) {
      conversations {
        ...ChatbotConversationFields
      }
      pageCount
      totalCount
    }
  }
`
